import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=00d0731b&scoped=true"
import script from "./productlist.vue?vue&type=script&lang=js"
export * from "./productlist.vue?vue&type=script&lang=js"
import style0 from "./productlist.vue?vue&type=style&index=0&id=00d0731b&prod&scoped=true&lang=css"
import style1 from "./productlist.vue?vue&type=style&index=1&id=00d0731b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d0731b",
  null
  
)

export default component.exports